import Tooltip from "../directives/tooltip";
import { defineNuxtPlugin } from "#app";

export default defineNuxtPlugin( {
  name: "apollo-tooltip",
  parallel: true,
  setup ( nuxtApp ) {
    nuxtApp.vueApp.directive( "tooltip", Tooltip );
  },
} );
